import { render, staticRenderFns } from "./AntecedentComponent.vue?vue&type=template&id=179cfc9d"
import script from "./AntecedentComponent.vue?vue&type=script&lang=js"
export * from "./AntecedentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports